import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { addEmailAdressReminder } from '../data/getAxiosRequests';
import { gyms } from '../constants/Consts';
import AutocompleteInput from '../components/UI/Autocomplete';

// ─── CDN base ────────────────────────────────────────────────────────────────
const CDN = 'https://cdn.prod.website-files.com/68ce578c9359063e607d9477';

// ─── Webflow exact design tokens ─────────────────────────────────────────────
const C = {
  primary400:   '#811fd6',
  primary500:   '#6a19af',
  primary100:   '#c598ec',
  primary25:    '#f2e9fb',
  secondary400: '#34b284',
  secondary100: '#a3e1ca',
  secondary25:  '#f0fff9',
  grey900:      '#101828',
  grey300:      '#d0d5dd',
  grey100:      '#f2f4f7',
  grey700:      '#344054',
  grey500:      '#667085',
};

// ─── Assets ──────────────────────────────────────────────────────────────────
const LOGO        = `${CDN}/68ce5e6f3114529d2b6ffeec_Vector%20(1).png`;
const APPSTORE    = `${CDN}/68ceb4a17b88ad4d56b8da57_image%209.png`;
const PLAYSTORE   = `${CDN}/68ceb4a10afdfa5ff8856966_image%2010.png`;
const APP_MOCKUP  = `${CDN}/68ceb42487ed86976562fedd_Frame%203910.png`;

const PARTNER_LOGOS = [
  `${CDN}/68d149351f0cdeabd19e410d_Frame%203954.png`,
  `${CDN}/68d149340236d623a5cf890a_Frame%203951.png`,
  `${CDN}/68d149340236d623a5cf8907_Frame%203949.png`,
  `${CDN}/68d1493417bae50d4821bc3a_Frame%203946.png`,
  `${CDN}/68d4fcce52e1990acd7c5b68_Frame%203956.png`,
  `${CDN}/68d14934b10a1070c12908a4_Frame%203955.png`,
  `${CDN}/68d14934eb6367a3f8211e0e_Frame%203950.png`,
  `${CDN}/68d149343318c8d4c2c68d8f_Frame%203947.png`,
  `${CDN}/68d149348ad2377ed7f892f6_Frame%203948.png`,
  `${CDN}/68d149252c9dc3c4c85fc6ec_Frame%203952%20(1).png`,
  `${CDN}/68d14d58e4de88224bcdb059_Frame%203953.png`,
];

const FEAT_SCREENS = [
  `${CDN}/68ceb424866f068b459f75ca_Salle%201.png`,
  `${CDN}/68ceb423f2a4d549f7e0da14_Screenshot%20progression%201.png`,
  `${CDN}/68ceb4243117b13140bce382_Ecran%20succes%201.png`,
];

const FEAT_ICONS = [
  `${CDN}/68ceb423b823b1ae93320a28_CheckCircle.png`,
  `${CDN}/68ceb423fbfcac9f4843155a_ChartBar.png`,
  `${CDN}/68ceb423dbbc8b730683d0c3_Users.png`,
];

const FEAT_DATA = [
  { title: 'Valide tes plus beaux blocs',   desc: 'Retrouve ta salle, ajoute tes blocs en 1 clic' },
  { title: 'Mesure tes progrès',            desc: 'Un index de 0 à 100, par style, dans toutes les salles' },
  { title: 'Partage avec ta communauté',    desc: "Un fil d'actualité, des classements et des défis à relever" },
];

const PARTNER_GYMS = [
  { name: 'Boulderline 1, 2, 3', city: 'Montpellier' },
  { name: 'Cortigrimpe 74',      city: 'Annecy' },
  { name: 'Mont Blanc Escalade', city: 'Les Houches' },
  { name: 'SUAPS Magnifac',      city: 'Lille' },
  { name: 'Cortigrimpe 01',      city: 'Saint Genis Pouilly' },
  { name: 'Contrepointe',        city: 'Bourges' },
  { name: 'Hardbloc',            city: 'Alfortville' },
  { name: 'Ablok',               city: 'Grenoble' },
  { name: 'Ablok',               city: 'Annecy' },
  { name: 'Ablok',               city: 'Voiron' },
  { name: 'Uniblok',             city: 'Carcassonne' },
  { name: 'Le Triangle',         city: 'Paris' },
];

const PARTNER_FEATS = [
  { icon: `${CDN}/68ced114e57aa4d75c55aa49_CheckFat%20(1).png`,    text: 'Topo officiel mis à jour',                          filter: undefined },
  { icon: `${CDN}/68ced22bb823b1ae9335caf7_ChartLine.png`,         text: 'Ton Gaston Index (indice universel de progression)', filter: undefined },
  { icon: `${CDN}/68ced22b43865248ab5cd8d7_Users%20(2).png`,       text: 'Des événements avec ta communauté',                 filter: undefined },
];

const COMMUNITY_GYMS = [
  { name: 'Atome',             city: 'Annecy' },
  { name: 'Space Bloc',        city: 'Annecy' },
  { name: 'Climb Up',          city: 'Aubervilliers' },
  { name: 'Ablok',             city: 'Annecy' },
  { name: 'Climb Up',          city: "Porte d'Italie" },
  { name: 'Arkose Chevaleret', city: 'Paris 13' },
  { name: 'Arkose Genevois',   city: 'Vétraz-Monthoux' },
  { name: 'Ablok',             city: 'Grenoble' },
  { name: 'Bloc Session',      city: 'Nancy' },
  { name: 'Bloc Session',      city: 'Ardennes' },
  { name: 'EV 3',              city: 'Grenoble' },
  { name: 'Le Topo',           city: 'Saint Gervais' },
  { name: 'Ablok',             city: 'Voiron' },
  { name: 'Uniblok',           city: 'Carcassonne' },
];

const COMMUNITY_FEATS = [
  { icon: `${CDN}/68ce77d111d817ead2394cf8_Users%20(1).png`,  text: 'Blocs référencés par la communauté',   sub: '' },
  { icon: `${CDN}/68ce77dc5b1d9dea0814d7a0_ChartLine.png`,   text: 'Ton Gaston Index',                     sub: '(indice universel de progression)' },
  { icon: `${CDN}/68ce77d1360c1ccf4357ee45_Trophy.png`,      text: 'Tes + beaux blocs validés',             sub: '' },
];

const SOCIAL_ICONS = [
  { src: `${CDN}/68ceb5701f34e5a010f73ba5_Frame%201501.png`, href: 'https://www.instagram.com/gaston_grimpe/',                     alt: 'Instagram' },
  { src: `${CDN}/68ceb570319e6069aeda9275_Frame%201502.png`, href: 'https://www.tiktok.com/@gaston_grimpe',                         alt: 'TikTok' },
  { src: `${CDN}/68ceb570d24863ab139118ba_Frame%201503.png`, href: 'https://www.youtube.com/@gaston_grimpe/featured',               alt: 'YouTube' },
  { src: `${CDN}/68ceb5702e3d642e1472c43e_Frame%201504.png`, href: 'https://www.linkedin.com/company/gaston-grimpe/',               alt: 'LinkedIn' },
];

// ─── Sub-components ───────────────────────────────────────────────────────────
const StoreBadges: React.FC<{ centered?: boolean }> = ({ centered }) => (
  <div style={{ display: 'flex', gap: '12px', justifyContent: centered ? 'center' : 'flex-start' }}>
    <a href="https://apps.apple.com/no/app/gastón/id6476766268" target="_blank" rel="noopener noreferrer">
      <img src={APPSTORE} alt="Télécharger sur l'App Store" style={{ height: '44px', display: 'block' }} />
    </a>
    <a href="https://play.google.com/store/apps/details?id=com.gastonclimbing" target="_blank" rel="noopener noreferrer">
      <img src={PLAYSTORE} alt="Disponible sur Google Play" style={{ height: '44px', display: 'block' }} />
    </a>
  </div>
);

// ─── Main component ───────────────────────────────────────────────────────────
const LandingPage: React.FC = () => {
  useEffect(() => {
    document.title = "Suivi d'escalade & défis – Gaston";
  }, []);

  const navigate = useNavigate();
  const [pathTab, setPathTab] = useState<'partner' | 'community'>('community');
  const [emailAdded, setEmailAdded] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const formik = useFormik({
    initialValues: { selectedGym: '', emailAddress: '', newsletter: false },
    validationSchema: Yup.object({
      selectedGym:  Yup.string().required("Tu n'as pas renseigné de salle"),
      emailAddress: Yup.string().email('Format invalide').required("Tu n'as pas renseigné ton adresse email"),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      setErrorMsg(null);
      addEmailAdressReminder(values.selectedGym, values.emailAddress)
        .then(res => { if (res.status === 201) setEmailAdded(true); })
        .catch(err => {
          if (err.response?.status === 400) {
            setErrorMsg(err.response.data.email?.[0] ?? "Une erreur s'est produite.");
          } else {
            setErrorMsg("Quelque chose ne s'est pas passé comme prévu, contacte-nous sur insta.");
          }
        })
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <div style={{ width: '100%', fontFamily: "'Nunito Sans', sans-serif", overflowX: 'hidden', maxWidth: '100vw' }}>

      {/* ── Global overrides scoped to landing page ───────────────────────── */}
      <style>{`
        /* Fix autocomplete width inside form */
        .lp-waitlist-form .autocomplete-container { width: 100% !important; }
        .lp-waitlist-form .input-select-gym       { width: 100% !important; box-sizing: border-box !important; }

        /* Marquee */
        @keyframes lp-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .lp-marquee-track { display: flex; animation: lp-marquee 30s linear infinite; width: max-content; align-items: center; }
        .lp-marquee-track img { height: 70px; margin: 0 28px; object-fit: contain; }

        /* Nav links */
        .lp-nav-link { color: #fff; font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 600;
          line-height: 24px; padding: 5px 10px; text-decoration: none; }
        .lp-nav-link:hover { opacity: .78; }

        /* Hero tab toggle */
        .lp-toggle-btn {
          border: none; border-radius: 50px; padding: 10px 28px; cursor: pointer;
          font-family: 'Nunito Sans', sans-serif; transition: background .15s, color .15s;
          display: flex; flex-direction: column; align-items: center; gap: 2px;
        }
        .lp-toggle-btn .lp-toggle-label    { font-size: 16px; font-weight: 800; line-height: 22px; }
        .lp-toggle-btn .lp-toggle-sublabel { font-size: 13px; font-weight: 400; line-height: 18px; }
        .lp-toggle-btn.active   { background: #fff; color: ${C.primary500}; }
        .lp-toggle-btn.inactive { background: transparent; color: #fff; }

        /* Primary CTA button */
        .lp-btn-primary {
          display: inline-block; background: #fff; color: ${C.primary500};
          border: none; border-radius: 8px; padding: 12px 16px;
          font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 700; line-height: 24px;
          text-decoration: none; cursor: pointer; transition: opacity .2s;
        }
        .lp-btn-primary:hover { opacity: .88; }

        /* Secondary (green) CTA button */
        .lp-btn-secondary {
          display: inline-block; background: ${C.secondary400}; color: #fff;
          border: none; border-radius: 8px; padding: 12px 16px;
          font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 700; line-height: 24px;
          text-decoration: none; cursor: pointer; transition: opacity .2s;
        }
        .lp-btn-secondary:hover { opacity: .88; }
        .lp-btn-secondary:disabled { cursor: not-allowed; }
        .lp-btn-secondary:disabled:hover { background: ${C.secondary100}; }

        /* Path tabs — pill toggle */
        .lp-path-toggle { display: inline-flex; background: #fff; border-radius: 50px; padding: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.12); }
        .lp-path-tab {
          border: none; border-radius: 50px; padding: 10px 24px; cursor: pointer;
          font-family: 'Nunito Sans', sans-serif; font-size: 15px; font-weight: 700; line-height: 22px;
          transition: background .15s, color .15s; white-space: nowrap;
        }
        .lp-path-tab.active   { background: ${C.secondary400}; color: #fff; }
        .lp-path-tab.inactive { background: transparent; color: ${C.primary400}; }


        /* Card base */
        .lp-card {
          border: 2px solid ${C.secondary100}; border-radius: 20px; padding: 24px; background: #fff;
        }
        .lp-card.primary-25  { border-color: ${C.primary100}; }
        .lp-card.primary-100 { border-color: ${C.primary100}; }
        .lp-btn-download { display:flex; align-items:center; justify-content:center; gap:10px; background:${C.primary400}; color:#fff; border-radius:8px; padding:14px 16px; font-family:'Nunito Sans',sans-serif; font-size:16px; font-weight:700; text-decoration:none; margin-top:24px; transition:background .2s; }
        .lp-btn-download:hover { background:${C.primary500}; }

        /* Gym chip */
        .lp-gym-chip {
          display: flex; align-items: flex-start; gap: 8px;
          background: ${C.grey100}; border-radius: 8px; padding: 8px 10px;
        }

        /* Form input */
        .lp-input {
          width: 100%; padding: 12px 14px; border: 1.5px solid ${C.grey300}; border-radius: 8px;
          font-family: 'Nunito Sans', sans-serif; font-size: 15px; outline: none; box-sizing: border-box;
          background: #fff;
        }
        .lp-input:focus { border-color: ${C.secondary400}; }

        /* Check row */
        .lp-check-row { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 12px; }

        /* Hamburger button */
        .lp-hamburger { display: none; flex-direction: column; gap: 5px; background: none; border: none; cursor: pointer; padding: 4px; }
        .lp-hamburger span { display: block; width: 24px; height: 2px; background: #fff; border-radius: 2px; }

        /* Mobile dropdown menu */
        .lp-mobile-menu {
          display: none; position: fixed; top: 72px; left: 0; right: 0; z-index: 99;
          background: ${C.primary500}; flex-direction: column; padding: 8px 0;
          box-shadow: 0 8px 24px rgba(0,0,0,.18);
        }
        .lp-mobile-menu.open { display: flex; }
        .lp-mobile-menu a { color: #fff; font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 600;
          padding: 14px 24px; text-decoration: none; border-bottom: 1px solid rgba(255,255,255,.1); }
        .lp-mobile-menu a:last-child { border-bottom: none; }
        .lp-mobile-menu a:hover { background: rgba(255,255,255,.1); }

        /* Responsive */
        @media (max-width: 991px) {
          .lp-hero-grid   { grid-template-columns: 1fr !important; }
          .lp-hero-right  { display: none !important; }
          .lp-feat-grid   { grid-template-columns: 1fr 1fr !important; }
          .lp-card-grid   { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 767px) {
          .lp-nav-links   { display: none !important; }
          .lp-hamburger   { display: flex !important; }
          .lp-feat-grid   { grid-template-columns: 1fr !important; }
          .lp-card-grid   { grid-template-columns: 1fr !important; }
          /* Hero */
          .lp-hero-section { padding: 48px 20px !important; min-height: auto !important; max-height: none !important; }
          .lp-hero-h1     { font-size: 2rem !important; line-height: 2.5rem !important; }
          .lp-hero-sub    { font-size: 1rem !important; line-height: 1.5rem !important; }
          .lp-feat-img    { height: 260px !important; }
          /* Path toggle: stack vertically, full width */
          .lp-path-toggle { flex-direction: column !important; width: 100% !important; box-sizing: border-box !important; }
          .lp-path-tab    { width: 100% !important; text-align: center !important; padding: 12px 16px !important; font-size: 14px !important; }
          /* Sections padding */
          .lp-section-pad { padding-left: 16px !important; padding-right: 16px !important; }
          /* Two-paths heading */
          .lp-two-paths-h2 { font-size: 1.6rem !important; line-height: 2.2rem !important; }
          /* Waitlist form */
          .lp-waitlist-form { max-width: 100% !important; }
        }
      `}</style>

      {/* ══════════════════════════════════════════════════
          NAVBAR
      ══════════════════════════════════════════════════ */}
      <nav style={{
        backgroundColor: C.primary400,
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        height: '72px',
        display: 'flex', alignItems: 'center',
        padding: '0 20px',
        boxSizing: 'border-box',
      }}>
        <div style={{
          width: '100%', maxWidth: '1100px', margin: '0 auto',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <a href="/">
            <img src={LOGO} alt="Gaston" style={{ width: '120px', display: 'block' }} />
          </a>
          <div className="lp-nav-links" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <a className="lp-nav-link" href="https://rotpunkttest.fr/monthly-challenge/"
               target="_blank" rel="noopener noreferrer">Classements</a>
            <a className="lp-nav-link" href="https://rotpunkttest.fr/login-pro"
               target="_blank" rel="noopener noreferrer">Mon espace ouvreur</a>
            <a className="lp-nav-link"
               href="https://calendly.com/jeremy-gaston/un-coup-d-oeil-chez-gaston"
               target="_blank" rel="noopener noreferrer">Nous rencontrer</a>
          </div>
          <button className="lp-hamburger" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile dropdown */}
      <div className={`lp-mobile-menu${menuOpen ? ' open' : ''}`}>
        <a href="https://rotpunkttest.fr/monthly-challenge/" target="_blank" rel="noopener noreferrer"
           onClick={() => setMenuOpen(false)}>Classements</a>
        <a href="https://rotpunkttest.fr/login-pro" target="_blank" rel="noopener noreferrer"
           onClick={() => setMenuOpen(false)}>Mon espace ouvreur</a>
        <a href="https://calendly.com/jeremy-gaston/un-coup-d-oeil-chez-gaston" target="_blank" rel="noopener noreferrer"
           onClick={() => setMenuOpen(false)}>Nous rencontrer</a>
      </div>

      {/* All page content sits below the fixed navbar */}
      <main style={{ marginTop: '72px', overflowX: 'hidden' }}>

      {/* ══════════════════════════════════════════════════
          HERO  (100vh, gradient 157deg primary→white)
      ══════════════════════════════════════════════════ */}
      <section
        className="lp-hero-section"
        style={{
          background: `linear-gradient(157deg, ${C.primary400} 50%, #fff 100%)`,
          minHeight: 'calc(100vh - 72px)', maxHeight: '928px',
          padding: '80px 30px',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
      >
        <div
          className="lp-hero-grid"
          style={{
            width: '100%', maxWidth: '1100px',
            display: 'grid', gridTemplateColumns: '1fr 1fr',
            gap: '40px', alignItems: 'center',
          }}
        >
          {/* ── Left column ── */}
          <div>
            {/* Grimpeur / Salle toggle */}
            <div style={{
              display: 'inline-flex',
              backgroundColor: 'rgba(255,255,255,.22)',
              borderRadius: '50px', padding: '6px',
              marginBottom: '32px',
            }}>
              <button className="lp-toggle-btn active">
                <span className="lp-toggle-label">Grimpeur</span>
                <span className="lp-toggle-sublabel">Je veux progresser</span>
              </button>
              <button
                className="lp-toggle-btn inactive"
                onClick={() => navigate('/pro')}
              >
                <span className="lp-toggle-label">Salle</span>
                <span className="lp-toggle-sublabel">Je gère une salle</span>
              </button>
            </div>

            <h1 className="lp-hero-h1" style={{
              fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
              fontSize: '48px', fontWeight: 600, lineHeight: '56px',
              color: '#fff', margin: '0 0 16px 0',
            }}>
              Installe Gaston,<br />grimpe + fort
            </h1>

            <p className="lp-hero-sub" style={{
              fontFamily: "'Nunito Sans', sans-serif",
              fontSize: '20px', fontWeight: 300, lineHeight: '26px',
              color: '#fff', marginBottom: '24px',
            }}>
              Valide tes plus beaux blocs, mesure tes progrès et partage avec ta communauté !
            </p>

            <button
              className="lp-btn-primary"
              style={{ marginBottom: '16px' }}
              onClick={() => {
                const target = document.getElementById('fonctionnalit-s');
                if (!target) return;
                const start = window.scrollY;
                const end = target.getBoundingClientRect().top + start;
                const duration = 1200;
                const startTime = performance.now();
                const ease = (t: number) => t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
                const step = (now: number) => {
                  const elapsed = now - startTime;
                  const progress = Math.min(elapsed / duration, 1);
                  window.scrollTo(0, start + (end - start) * ease(progress));
                  if (progress < 1) requestAnimationFrame(step);
                };
                requestAnimationFrame(step);
              }}
            >
              Je veux découvrir l'app
            </button>

            <p style={{
              fontFamily: "'Nunito Sans', sans-serif",
              fontSize: '14px', fontWeight: 300, lineHeight: '20px',
              color: 'rgba(255,255,255,.85)',
              margin: '16px 0 24px',
            }}>
              Déjà 3 000 grimpeurs actifs sur la communauté
            </p>

            <StoreBadges />
          </div>

          {/* ── Right column — app screenshot ── */}
          <div
            className="lp-hero-right"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}
          >
            <img
              src={APP_MOCKUP}
              alt="Aperçu de l'application Gaston"
              style={{ width: '120%', maxWidth: '520px', display: 'block' }}
            />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          PARTNER GYMS MARQUEE
      ══════════════════════════════════════════════════ */}
      <div style={{ backgroundColor: '#fff', padding: '48px 0' }}>
        <h2 style={{
          fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
          fontSize: '26px', fontWeight: 500, color: C.grey900,
          textAlign: 'center', marginBottom: '32px',
          padding: '0 30px',
        }}>
          Nos salles partenaires
        </h2>
        <div style={{ overflow: 'hidden', width: '100%' }}>
          <div className="lp-marquee-track">
            {[...PARTNER_LOGOS, ...PARTNER_LOGOS].map((src, i) => (
              <img key={i} src={src} alt="Salle partenaire" />
            ))}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════
          FEATURES  ("Grimper, progresser, partager")
          purple gradient bg, 3 screenshots + bottom cards
      ══════════════════════════════════════════════════ */}
      <section
        id="fonctionnalit-s"
        style={{
          background: `linear-gradient(13deg, ${C.primary400} 56%, #fff 100%)`,
          padding: '64px 30px',
        }}
      >
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
            fontSize: '40px', fontWeight: 600, lineHeight: '48px',
            color: '#fff', marginBottom: '48px', textAlign: 'center',
          }}>
            Grimper, progresser, partager
          </h2>

          {/* 3-column grid: screenshots on top, bottom cards below */}
          <div
            className="lp-feat-grid"
            style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', marginBottom: '40px' }}
          >
            {FEAT_DATA.map((feat, i) => (
              <div key={i} style={{ display: 'flex', flexDirection: 'column' }}>
                {/* Screenshot */}
                <div style={{
                  flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
                  marginBottom: '16px',
                }}>
                  <img
                    src={FEAT_SCREENS[i]}
                    alt={feat.title}
                    className="lp-feat-img"
                    style={{ height: '500px', width: 'auto', objectFit: 'contain', display: 'block' }}
                  />
                </div>
                {/* Bottom card — icon left, text right, no background */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <img src={FEAT_ICONS[i]} alt="" style={{ width: '28px', height: '28px', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                    <p style={{
                      fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
                      fontSize: '18px', fontWeight: 700, color: '#fff',
                      margin: '0 0 4px 0',
                    }}>
                      {feat.title}
                    </p>
                    <p style={{
                      fontFamily: "'Nunito Sans', sans-serif",
                      fontSize: '15px', fontWeight: 400, lineHeight: '22px',
                      color: 'rgba(255,255,255,.9)', margin: 0,
                    }}>
                      {feat.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <StoreBadges centered />
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          TWO PATHS  ("Deux voies pour découvrir Gaston")
      ══════════════════════════════════════════════════ */}
      <section className="lp-section-pad" style={{ padding: '64px 30px', backgroundColor: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

          <h2 className="lp-two-paths-h2" style={{
            fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
            fontSize: '36px', fontWeight: 600, lineHeight: '44px',
            color: C.grey900, textAlign: 'center', marginBottom: '32px',
          }}>
            Deux voies pour découvrir Gaston
          </h2>

          {/* Pill toggle — centered */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px', overflow: 'hidden' }}>
            <div className="lp-path-toggle" style={{ maxWidth: '100%' }}>
              <button
                className={`lp-path-tab ${pathTab === 'partner' ? 'active' : 'inactive'}`}
                onClick={() => setPathTab('partner')}
              >
                Ma salle est partenaire
              </button>
              <button
                className={`lp-path-tab ${pathTab === 'community' ? 'active' : 'inactive'}`}
                onClick={() => setPathTab('community')}
              >
                Ma salle n'est pas partenaire
              </button>
            </div>
          </div>

          {/* ── PARTNER tab content ── */}
          {pathTab === 'partner' && (
            <div className="lp-card-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 2fr', gap: '24px' }}>
              {/* Gym chips card */}
              <div className="lp-card primary-25">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                  <img src={`${CDN}/68ceced6c5230dba4bba4820_SealCheck.png`} alt="" style={{ width: '20px', height: '20px' }} />
                  <span style={{
                    fontFamily: "'Nohemi', sans-serif",
                    fontSize: '16px', fontWeight: 700, color: C.grey900,
                  }}>
                    Salles partenaires
                  </span>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {PARTNER_GYMS.map((gym, i) => (
                    <div key={i} className="lp-gym-chip">
                      <img src={`${CDN}/68ced114e57aa4d75c55aa49_CheckFat%20(1).png`} alt="✓"
                        style={{ width: '16px', height: '16px', marginTop: '2px', flexShrink: 0 }} />
                      <div>
                        <div style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', fontWeight: 700, color: C.grey900, lineHeight: '18px' }}>
                          {gym.name}
                        </div>
                        <div style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '11px', fontWeight: 400, color: C.grey500, lineHeight: '16px' }}>
                          {gym.city}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Features + CTA card */}
              <div className="lp-card primary-25" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: C.primary25 }}>
                <div>
                  <p style={{
                    fontFamily: "'Nohemi', sans-serif",
                    fontSize: '18px', fontWeight: 700, color: C.grey900,
                    margin: '0 0 20px 0', lineHeight: '26px',
                  }}>
                    Ton expérience Gaston t'attend
                  </p>
                  {PARTNER_FEATS.map((f, i) => (
                    <div key={i} className="lp-check-row" style={{ marginBottom: '16px' }}>
                      <img src={f.icon} alt="" style={{ width: '24px', height: '24px', flexShrink: 0, filter: f.filter }} />
                      <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '15px', fontWeight: 400, color: C.grey900 }}>
                        {f.text}
                      </span>
                    </div>
                  ))}
                </div>
                <a href="https://www.gaston-grimpe.com/redirect-store/" target="_blank" rel="noopener noreferrer"
                  className="lp-btn-download"
                >
                  <img src={`${CDN}/68cebc8ad3dcef9b8b19597e_DownloadSimple.png`} alt="" style={{ width: '20px', height: '20px' }} />
                  Télécharge l'app maintenant
                </a>
              </div>
            </div>
          )}

          {/* ── COMMUNITY tab content ── */}
          {pathTab === 'community' && (
            <div className="lp-card-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 2fr', gap: '24px' }}>

              {/* Left: gym chips card */}
              <div className="lp-card secondary-25">
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <img src={`${CDN}/68ceb500cc974b96262ad10d_Plant.png`} alt="" style={{ width: '20px', height: '20px' }} />
                  <span style={{
                    fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
                    fontSize: '16px', fontWeight: 600, color: C.grey900,
                  }}>
                    Salles communautaires
                  </span>
                </div>
                <p style={{
                  fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', fontWeight: 400,
                  color: C.grey900, margin: '0 0 16px 0', lineHeight: '18px',
                }}>
                  Les blocs sont mis à jour par les grimpeurs (🛠️ on construit ce mode avec vous)
                </p>

                {/* Gym chips grid */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {COMMUNITY_GYMS.map((gym, i) => (
                    <div key={i} className="lp-gym-chip">
                      <img src={`${CDN}/68ceb500bfb7916aaa569f5f_CheckFat.png`} alt="✓"
                        style={{ width: '16px', height: '16px', marginTop: '2px', flexShrink: 0 }} />
                      <div>
                        <div style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', fontWeight: 700, color: C.grey900, lineHeight: '18px' }}>
                          {gym.name}
                        </div>
                        <div style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '11px', fontWeight: 400, color: C.grey500, lineHeight: '16px' }}>
                          {gym.city}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right: features + CTA card */}
              <div className="lp-card secondary-25" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <p style={{
                    fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
                    fontSize: '20px', fontWeight: 700, color: C.grey900,
                    margin: '0 0 24px 0', lineHeight: '28px',
                  }}>
                    Référence tes propres blocs, suis ta progression
                  </p>
                  {COMMUNITY_FEATS.map((f, i) => (
                    <div key={i} className="lp-check-row" style={{ marginBottom: '16px', alignItems: 'flex-start' }}>
                      <img src={f.icon} alt="" style={{ width: '22px', height: '22px', flexShrink: 0, marginTop: '2px' }} />
                      <div>
                        <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '15px', fontWeight: 400, color: C.grey900 }}>
                          {f.text}
                        </span>
                        {f.sub && (
                          <div style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', fontWeight: 400, color: C.grey500 }}>
                            {f.sub}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <a href="https://www.gaston-grimpe.com/redirect-store/" target="_blank" rel="noopener noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                    backgroundColor: C.secondary400, color: '#fff', borderRadius: '8px', padding: '14px 16px',
                    fontFamily: "'Nunito Sans', sans-serif", fontSize: '16px', fontWeight: 700,
                    textDecoration: 'none', marginTop: '24px',
                  }}
                >
                  <img src={`${CDN}/68cebc8ad3dcef9b8b19597e_DownloadSimple.png`} alt="" style={{ width: '20px', height: '20px' }} />
                  Teste le mode communautaire
                </a>
              </div>
            </div>
          )}

          {/* ── Waitlist form (community/no-partner only) ── */}
          {pathTab === 'community' && <div style={{ marginTop: '64px', textAlign: 'center' }}>
            <h2 style={{
              fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
              fontSize: '36px', fontWeight: 600, lineHeight: '44px',
              color: C.grey900, marginBottom: '8px',
            }}>
              Demande ta salle en partenaire sur Gaston 👇
            </h2>
            <p style={{
              fontFamily: "'Nunito Sans', sans-serif",
              fontSize: '16px', fontWeight: 300, lineHeight: '24px',
              color: C.grey500, marginBottom: '32px',
            }}>
              L'expérience Gaston avec la garantie d'avoir tous les blocs à jour dans l'app
            </p>

            {emailAdded ? (
              <div style={{
                maxWidth: '500px', margin: '0 auto',
                padding: '24px', borderRadius: '16px',
                border: `2px solid ${C.secondary100}`,
                backgroundColor: C.secondary25,
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px',
              }}>
                <img
                  src={`${CDN}/68d10bb0ecf408940f55a6e9_CheckCircle%20(1).png`}
                  alt="Succès"
                  style={{ width: '40px', height: '40px' }}
                />
                <p style={{
                  fontFamily: "'Nohemi', 'Nunito Sans', sans-serif",
                  fontSize: '20px', fontWeight: 600, color: C.grey900, margin: 0,
                }}>
                  Demande prise en compte
                </p>
                <p style={{
                  fontFamily: "'Nunito Sans', sans-serif",
                  fontSize: '15px', fontWeight: 300, color: C.grey500, margin: 0,
                }}>
                  On te préviendra quand ta salle sera partenaire.
                </p>
              </div>
            ) : (
              <form
                onSubmit={formik.handleSubmit}
                className="lp-waitlist-form"
                style={{
                  maxWidth: '500px', margin: '0 auto',
                  padding: '24px', borderRadius: '16px',
                  border: `2px solid ${C.secondary100}`,
                  backgroundColor: C.secondary25,
                  display: 'flex', flexDirection: 'column', gap: '14px',
                }}
              >
                <p style={{
                  fontFamily: "'Nohemi', sans-serif",
                  fontSize: '18px', fontWeight: 700, color: C.grey900,
                  margin: 0, textAlign: 'left', lineHeight: '26px',
                }}>
                  Dis-nous où tu grimpes, on priorise les salles les plus demandées
                </p>

                <div>
                  <label style={{
                    display: 'block',
                    fontFamily: "'Nunito Sans', sans-serif",
                    fontSize: '14px', fontWeight: 700, color: C.grey900,
                    marginBottom: '6px', textAlign: 'left',
                  }}>
                    Mon mail
                  </label>
                  <input
                    className="lp-input"
                    type="email"
                    name="emailAddress"
                    placeholder="exemple@mail.com"
                    value={formik.values.emailAddress}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.emailAddress && formik.errors.emailAddress && (
                    <p style={{ color: '#e7132c', fontSize: '13px', margin: '4px 0 0', textAlign: 'left' }}>
                      {formik.errors.emailAddress}
                    </p>
                  )}
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontFamily: "'Nunito Sans', sans-serif",
                    fontSize: '14px', fontWeight: 700, color: C.grey900,
                    marginBottom: '6px', textAlign: 'left',
                  }}>
                    Ma salle
                  </label>
                  <select
                    className="lp-input"
                    name="selectedGym"
                    value={formik.values.selectedGym}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ appearance: 'auto' }}
                  >
                    <option value="">Sélectionne ta salle</option>
                    {gyms.map((gym: { id: string; name: string }) => (
                      <option key={gym.id} value={gym.name}>{gym.name}</option>
                    ))}
                  </select>
                  {formik.touched.selectedGym && formik.errors.selectedGym && (
                    <p style={{ color: '#e7132c', fontSize: '13px', margin: '4px 0 0', textAlign: 'left' }}>
                      {formik.errors.selectedGym}
                    </p>
                  )}
                </div>

                <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', textAlign: 'left' }}>
                  <input
                    type="checkbox"
                    name="newsletter"
                    checked={formik.values.newsletter}
                    onChange={formik.handleChange}
                    style={{ marginTop: '3px', accentColor: C.secondary400, flexShrink: 0 }}
                  />
                  <span style={{
                    fontFamily: "'Nunito Sans', sans-serif",
                    fontSize: '13px', color: C.grey500, lineHeight: '18px',
                  }}>
                    Je veux suivre les avancées de Gaston et m'inscrire à la newsletter
                  </span>
                </label>

                <button
                  className="lp-btn-secondary"
                  type="submit"
                  disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
                  style={{ width: '100%', textAlign: 'center', fontWeight: 700 }}
                >
                  Rejoindre la liste d'attente
                </button>

                {errorMsg && (
                  <p style={{
                    color: '#e7132c', fontSize: '14px', margin: 0,
                    fontFamily: "'Nunito Sans', sans-serif",
                  }}>
                    {errorMsg}
                  </p>
                )}
              </form>
            )}
          </div>}

        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          FOOTER  (social icons from CDN + legal links)
      ══════════════════════════════════════════════════ */}
      <footer style={{
        backgroundColor: C.primary400,
        borderTop: '1px solid rgba(255,255,255,.18)',
        padding: '28px 30px',
      }}>
        <div style={{
          maxWidth: '1100px', margin: '0 auto',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px',
        }}>
          {/* Social icons */}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            {SOCIAL_ICONS.map(s => (
              <a key={s.alt} href={s.href} target="_blank" rel="noopener noreferrer">
                <img src={s.src} alt={s.alt} style={{ width: '40px', height: '40px', display: 'block' }} />
              </a>
            ))}
          </div>

          {/* Legal */}
          <div style={{ display: 'flex', gap: '24px' }}>
            <a
              href="https://rotpunkttest.fr/general-conditions"
              target="_blank" rel="noopener noreferrer"
              style={{
                color: 'rgba(255,255,255,.75)',
                fontFamily: "'Nunito Sans', sans-serif",
                fontSize: '14px', textDecoration: 'none',
              }}
            >
              Mentions légales
            </a>
            <a
              href="https://rotpunkttest.fr/personnal-data"
              target="_blank" rel="noopener noreferrer"
              style={{
                color: 'rgba(255,255,255,.75)',
                fontFamily: "'Nunito Sans', sans-serif",
                fontSize: '14px', textDecoration: 'none',
              }}
            >
              Confidentialité
            </a>
          </div>
        </div>
      </footer>

      </main>
    </div>
  );
};

export default LandingPage;
